<template>
  <el-dialog :title="title" :visible.sync="visible" width="40%" :before-close="closeModal">
    <el-form ref="meal" :model="meal" :rules="formRules" @submit.prevent.native="saveFn">
      <el-form-item label="Название" prop="title">
        <el-input
          v-model="meal.title"
          placeholder="Название категории приема пищи"
          autocomplete="off"
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">Закрыть</el-button>
      <el-button type="primary" :loading="loading" @click="saveFn"> Сохранить </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { LOADING, SELECTED, ERROR } from '../shared/state/types/getter_types';
import { STORE_MEAL, UPDATE_MEAL, SELECT_MEAL_RESET } from '../shared/state/types/action_types';
import { notifyMixin } from '../shared/mixins/notify-mixin';

export default {
  name: 'MealsModal',
  mixins: [notifyMixin],
  props: {
    title: {
      type: String,
      default: 'Добавить категорию приема пищи',
    },
    show: {
      type: Boolean,
      required: true,
    },
    action: {
      type: String,
      default: 'create',
    },
  },
  data() {
    return {
      formRules: {
        title: [{ required: true, message: 'Введите название', trigger: 'blur' }],
      },
    };
  },
  computed: {
    visible: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('update:show', value);
      },
    },
    ...mapGetters({ loading: LOADING, meal: SELECTED, error: ERROR }),
  },
  methods: {
    ...mapActions({
      store: STORE_MEAL,
      update: UPDATE_MEAL,
      reset: SELECT_MEAL_RESET,
    }),
    closeModal() {
      this.visible = false;
      this.reset();
    },
    async saveFn() {
      switch (this.action) {
        case 'edit':
          await this.update(this.meal);
          if (this.error) {
            this.showErrorMessage('Ошибка обновления');
          }
          this.showSuccessMessage('Успешно обновлен');
          this.closeModal();
          break;
        default:
          await this.store(this.meal);
          if (this.error) {
            this.showErrorMessage('Ошибка добавления');
          }
          this.showSuccessMessage('Успешно добавлен');
          this.closeModal();
          break;
      }
    },
  },
};
</script>
